
import { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate, Link } from 'react-router-dom';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function Register() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-currency-line text-white text-2xl"></i>
            </div>
          </Link>
          <h2 className="text-3xl font-bold text-gray-900">Registration Disabled</h2>
          <p className="mt-2 text-gray-600">New registrations are currently not available</p>
        </div>

        <Card>
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-lock-line text-red-600 text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Access Restricted</h3>
            <p className="text-gray-600 mb-6">
              Registration is currently disabled. This platform is restricted to authorized users only.
            </p>
            <div className="space-y-3">
              <Link to="/login">
                <Button className="w-full">
                  Sign In Instead
                </Button>
              </Link>
              <Link to="/" className="block text-blue-600 hover:text-blue-500 font-medium">
                ← Back to Home
              </Link>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
